(ns journal-app-client.modals.default
  (:require [journal-app-client.components.modal :as m]))

(defn main [id props]
  [m/body
   [:p.subtitle (str "Modal content for modal with id " id " not found")]
   [:p.subtitle "Props"]
   [:p.help (str props)]])

